import { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

// Full-screen image viewer with prev/next arrows + keyboard nav.
// images: [{ url, caption }]. Copy deterrents applied (no drag / no right-click).
export function Lightbox({ images, startIndex = 0, onClose }) {
  const [i, setI] = useState(startIndex);
  const count = images?.length || 0;

  useEffect(() => { setI(startIndex); }, [startIndex]);
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
      else if (e.key === "ArrowLeft") setI((v) => (v - 1 + count) % count);
      else if (e.key === "ArrowRight") setI((v) => (v + 1) % count);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [count, onClose]);

  if (!count) return null;
  const cur = images[i];
  const prev = (e) => { e?.stopPropagation(); setI((v) => (v - 1 + count) % count); };
  const next = (e) => { e?.stopPropagation(); setI((v) => (v + 1) % count); };

  return (
    <div onClick={onClose} onContextMenu={(e) => e.preventDefault()} className="fixed inset-0 z-[120] flex select-none items-center justify-center bg-black/90 p-4" data-testid="lightbox">
      <button onClick={onClose} data-testid="lightbox-close" aria-label="Close" className="absolute right-4 top-4 grid h-10 w-10 place-items-center rounded-full bg-white/15 text-white transition-colors hover:bg-white/25"><X className="h-5 w-5" /></button>
      {count > 1 && <button onClick={prev} data-testid="lightbox-prev" aria-label="Previous" className="absolute left-3 top-1/2 grid h-11 w-11 -translate-y-1/2 place-items-center rounded-full bg-white/15 text-white transition-colors hover:bg-white/25"><ChevronLeft className="h-6 w-6" /></button>}
      {count > 1 && <button onClick={next} data-testid="lightbox-next" aria-label="Next" className="absolute right-3 top-1/2 grid h-11 w-11 -translate-y-1/2 place-items-center rounded-full bg-white/15 text-white transition-colors hover:bg-white/25"><ChevronRight className="h-6 w-6" /></button>}
      <figure className="flex max-h-[92vh] max-w-[94vw] flex-col items-center" onClick={(e) => e.stopPropagation()}>
        <img src={cur.url} alt={cur.caption || ""} draggable={false} onDragStart={(e) => e.preventDefault()} onContextMenu={(e) => e.preventDefault()}
          className="max-h-[86vh] max-w-[94vw] rounded-lg object-contain" style={{ WebkitUserSelect: "none", userSelect: "none", WebkitTouchCallout: "none" }} />
        <figcaption className="mt-3 text-center text-sm text-white/80">{cur.caption}{count > 1 && <span className="ml-2 text-white/50">{i + 1} / {count}</span>}</figcaption>
      </figure>
    </div>
  );
}
